import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogService } from '@nebular/theme';
import { BucketService, IFile } from '../../../services/bucket.service';
import { FilePreviewPanelComponent } from '../../panels/file-preview-panel/file-preview-panel.component';

@Component({
  selector: 'app-file-row-actions',
  template: `
    <div class="actions-row">
      <button
        nbButton
        ghost
        size="tiny"
        (click)="onView($event)"
        nbTooltip="{{ 'buttons.view' | translate }}"
        nbTooltipPlacement="top"
      >
        <nb-icon icon="eye-outline"></nb-icon>
      </button>
      <button
        nbButton
        ghost
        size="tiny"
        (click)="onDownload($event)"
        nbTooltip="{{ 'buttons.download' | translate }}"
        nbTooltipPlacement="top"
      >
        <nb-icon icon="download-outline"></nb-icon>
      </button>
    </div>
  `,
  styles: [
    `
      .actions-row {
        display: flex;
        gap: 0.125rem;
        align-items: center;
      }
    `,
  ],
})
export class FileRowActionsComponent {
  @Input() row!: IFile;

  constructor(
    private dialogService: NbDialogService,
    private bucketService: BucketService,
    private sanitizer: DomSanitizer,
  ) {}

  onView(event: Event) {
    event.stopPropagation();
    this.dialogService.open(FilePreviewPanelComponent, {
      context: { file: this.row },
      hasScroll: true,
      closeOnBackdropClick: true,
    });
  }

  onDownload(event: Event) {
    event.stopPropagation();
    const fileId = (this.row as any)?.datatype_id || String(this.row?.id);
    if (!fileId) return;

    this.bucketService.getPreviewUrl(fileId).subscribe((info) => {
      const a = document.createElement('a');
      a.href = info.url;
      a.download = info.file_name || 'download';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }
}
